// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1TVZ5","content":"RecentSearches_content__-MNFq"};